import React, { useState } from 'react';
import { FaTimes, FaDownload } from 'react-icons/fa'; 
import {  } from 'react-icons/gi'; 
const Android_Project = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const handleProjectClick = (projectName) => {
    if (expandedProject === projectName) {
      setExpandedProject(null);
    } else {
      setExpandedProject(projectName);
    }
  };
  const [downloading, setDownloading] = useState(false);

  const handleClick = () => {
    setDownloading(true);
    setTimeout(() => {
    setDownloading(false);
    window.location.href = "Global_chat.apk";
    }, 3000);
  };
  return (
    <>
      <div className="parent-react-project">
        <div className="child-react-project" onClick={() => handleProjectClick('Project1')} title='click for more details'>
          <div className="sub-child-project">
            <img src="ap1.jpg" alt="Project 2"></img>
          </div>
          <p>Chat Application, Android</p>
          <h3>Global Chat</h3>
          <h4>Read More</h4>
        </div>
        
      </div>
      {expandedProject && (
        <div className="expanded-details-overlay">
          <div className="expanded-details">
            <div className="close-icon" onClick={() => setExpandedProject(null)}>
              <FaTimes />
            </div>
            {expandedProject === 'Project1' && (
              <>
              <h2>Global Chat </h2>
              <div class="react-project-details">
                <div class="child-react-project-details">
                    <h3><span>Project : </span>Android Application</h3>
                    <h3><span>Languages : </span>Android Studio</h3>
                </div>
                <div class="child-react-project-details">
                    
                </div>
              </div>
              <div class="child-react-project-details-1">
                <p>Description:</p>
                <p>Global Chat is a dynamic Android application developed using Android Studio, XML, and Java. The app facilitates seamless communication among users worldwide. Leveraging Firebase as the backend, Global Chat ensures reliable data storage and real-time messaging functionality. Users can download the APK file to experience the app firsthand.</p>
                <p>For Developers:</p>
                <p>Global Chat's frontend, meticulously crafted by Prince Maurya, employs XML for layout design and Java for functionality implementation within Android Studio. The backend leverages Firebase Firestore for efficient data storage and Firebase Cloud Messaging for instantaneous messaging features. The APK file, developed by Prince Maurya, is readily available for users to enjoy the app's global chat experience.</p>
                <hr></hr>
                <h4>Download a android application<br></br>  👇</h4>
                <button onClick={handleClick}> {downloading ? <FaDownload /> : null}{downloading ? 'Downloading' : 'Download'}</button>
              </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Android_Project;
